<template>
  <div @mousewheel="common.startNoopInterval" @click="common.startNoopInterval">
    <Header></Header>
    <div class="search">
      <div class="w search-box d-flex align-items-center">
        <div class="logo d-flex align-items-center">
          <router-link to="/" :title="common_info.store.name"
            ><img
              class="img-default search-img"
              :src="common_info.store.logo"
              :alt="common_info.store.name"
          /></router-link>
          <div class="shoper">购物车</div>
        </div>
        <div class="search-c">
          <div class="search-item">
            <div class="box">
              <img
                class="img-default img"
                src="../../assets/images/search.png"
                alt
              />
              <input
                placeholder="搜索商品"
                class="search-input"
                type="text"
                v-model="searchtext"
                ref="searchtext"
              />
            </div>
            <div class="search-btn" @click="searchshop()">搜索</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="w">
        <div class="title d-flex align-items-center">
          <div
            class="title-item d-flex align-items-center justify-content-center"
            @click="checkAll()"
            style="width: 7%; height: 40px; cursor: pointer"
          >
            <div class="all-img">
              <img
                class="img-default"
                v-if="check_all"
                src="../../assets/images/select_checked.png"
                alt
              />
              <img
                class="img-default"
                v-else
                src="../../assets/images/select_unchecked.png"
                alt
              />
            </div>
            全选
          </div>
          <div
            class="title-item d-flex justify-content-center"
            style="width: 25%"
          >
            商品信息
          </div>
          <div
            class="title-item d-flex justify-content-center"
            style="width: 12%"
          >
            规格
          </div>
          <div
            class="title-item d-flex justify-content-center"
            style="width: 18%"
          >
            单价（元）
          </div>
          <div
            class="title-item d-flex justify-content-center"
            style="width: 14%"
          >
            数量
          </div>
          <div
            class="title-item d-flex justify-content-center"
            style="width: 12%"
          >
            小计（元）
          </div>
          <div
            class="title-item d-flex justify-content-center"
            style="width: 12%"
          >
            操作
          </div>
        </div>
        <div class="catshop">
          <template v-if="ttshop_mchlist.length || ttshop_catlist.length">
            <!-- 店铺商品 -->
            <template v-if="ttshop_mchlist && ttshop_mchlist.length">
              <template v-for="(item, index) in ttshop_mchlist">
                <template v-if="item.list && item.list.length">
                  <div class="shop-title d-flex align-items-center">
                    <div class="shop-titles d-flex align-items-center">
                      <div class="checkbox" @click="checkGroup(1, index)">
                        <img
                          class="img-default"
                          v-if="item.checked"
                          src="../../assets/images/select_checked.png"
                          alt
                        />
                        <img
                          class="img-default"
                          v-else
                          src="../../assets/images/select_unchecked.png"
                          alt
                        />
                      </div>
                      <div class="shop-name" v-text="item.name"></div>
                      <div class="checkbox">
                        <img class="img-default" :src="item.logo" alt />
                      </div>
                    </div>
                  </div>
                  <div class="goods-box">
                    <template v-for="(itemChild, indexChild) in item.list">
                      <div class="goods d-flex align-items-center">
                        <div
                          class="goods-checkbox-box d-flex align-items-center justify-content-center"
                          style="width: 4%"
                        >
                          <div
                            class="item checkWrap not-num"
                            v-if="
                              itemChild.status != 1 ||
                              itemChild.goods_is_del == 1
                            "
                          >
                            <div>失效</div>
                          </div>
                          <div
                            class="item checkWrap not-num"
                            v-else-if="itemChild.disabled"
                          >
                            <div>无货</div>
                          </div>
                          <div
                            class="goods-checkbox"
                            @click="checkItem(1, indexChild, index)"
                            v-else
                          >
                            <img
                              class="img-default"
                              v-if="itemChild.checked"
                              src="../../assets/images/select_checked.png"
                              alt
                            />
                            <img
                              class="img-default"
                              v-else
                              src="../../assets/images/select_unchecked.png"
                              alt
                            />
                          </div>
                        </div>

                        <router-link
                          :to="{
                            path: '/pages/goods/goods',
                            query: { id: itemChild.goods_id },
                          }"
                          target="_blank"
                          class="goods-details d-flex align-items-center justify-content-center"
                          style="width: 28%"
                        >
                          <div class="goods-img">
                            <img
                              class="img-default"
                              :src="itemChild.goods_pic"
                              alt
                            />
                          </div>
                          <div
                            class="goods-name"
                            v-text="itemChild.goods_name"
                          ></div>
                        </router-link>
                        <div
                          class="goods-size d-flex justify-content-center"
                          style="width: 12%"
                        >
                          <div>
                            <div
                              class="goods-size-item"
                              v-for="(
                                itemAttr, indexAttr
                              ) in itemChild.attr_list"
                              :key="indexAttr"
                            >
                              {{ itemAttr.attr_group_name }}：{{
                                itemAttr.attr_name
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="goods-pic d-flex justify-content-center"
                          style="width: 18%"
                        >
                          ¥ {{ itemChild.unitPrice }}
                        </div>
                        <div
                          class="goods-num d-flex justify-content-center"
                          style="width: 14%"
                        >
                          <template
                            v-if="
                              itemChild.max_num > 0 &&
                              itemChild.max_num < itemChild.num
                            "
                          >
                            <p class="num-warning">
                              仅剩库存{{ itemChild.max_num }}个
                            </p>
                          </template>
                          <el-input-number
                            v-model="itemChild.num"
                            @change="handleChange(itemChild.num, index)"
                            :min="1"
                            :max="
                              itemChild.max_num >= itemChild.num
                                ? itemChild.max_num
                                : itemChild.num
                            "
                            label="描述文字"
                          ></el-input-number>
                        </div>
                        <div
                          class="goods-subtotal d-flex justify-content-center"
                          style="width: 12%"
                        >
                          ¥
                          {{ (itemChild.num * itemChild.unitPrice).toFixed(2) }}
                        </div>
                        <div
                          class="goods-btn d-flex justify-content-center"
                          style="width: 12%"
                        >
                          <div>
                            <div
                              class="goods-btn-item goods-btn-itemer"
                              v-if="false"
                            >
                              收藏
                            </div>
                            <div
                              class="goods-btn-item"
                              @click="deleteItem(1, indexChild, index)"
                            >
                              删除
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </template>
            </template>
            <!-- 平台自营 -->
            <template v-if="ttshop_catlist && ttshop_catlist.length">
              <div class="shop-title d-flex align-items-center">
                <div class="shop-titles d-flex align-items-center">
                  <div class="checkbox" @click="checkGroup(2)">
                    <img
                      class="img-default"
                      v-if="check_list"
                      src="../../assets/images/select_checked.png"
                      alt
                    />
                    <img
                      class="img-default"
                      v-else
                      src="../../assets/images/select_unchecked.png"
                      alt
                    />
                  </div>
                  <div class="shop-name">平台自营</div>
                  <div class="checkbox">
                    <img class="img-default" :src="cart_info.plat_logo" alt />
                  </div>
                </div>
                <div class="coupon-box" v-if="false">
                  <div class="coupon d-flex align-items-center">
                    <div class="item d-flex">
                      <div
                        class="item-l d-flex justify-content-center align-items-center"
                      >
                        ¥10
                      </div>
                      <div
                        class="item-r d-flex justify-content-center align-items-center"
                      >
                        优惠券
                      </div>
                    </div>
                    <div class="coupon-img">
                      <img
                        class="img-default"
                        src="../../assets/images/bottom_14.png"
                        alt
                      />
                    </div>
                  </div>
                  <div class="coupon-po">
                    <div class="coupon-po-item d-flex align-items-center">
                      <div
                        class="coupon-po-img d-flex align-items-center justify-content-center"
                      >
                        <div class="coupon-po-name"><span>￥</span>10</div>
                      </div>
                      <div class="coupon-time">
                        <div>满¥199减¥10</div>
                        <div>截止日期：2020-10-19 至 2020-12-28</div>
                      </div>
                      <div
                        class="coupon-btn d-flex align-items-center justify-content-center"
                      >
                        再次领取
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 商品 -->
              <div class="goods-box">
                <template v-for="(item, index) in ttshop_catlist">
                  <!-- 普通商品 -->
                  <div
                    class="goods d-flex align-items-center"
                    v-if="item.parts_id == 0"
                  >
                    <div
                      class="goods-checkbox-box d-flex align-items-center justify-content-center"
                      style="width: 4%"
                    >
                      <div
                        class="item checkWrap not-num"
                        v-if="item.status != 1 || item.goods_is_del == 1"
                      >
                        <div>失效</div>
                      </div>
                      <div
                        class="item checkWrap not-num"
                        v-else-if="item.disabled"
                      >
                        <div>无货</div>
                      </div>
                      <div
                        class="goods-checkbox"
                        @click="checkItem(2, index)"
                        v-else
                      >
                        <img
                          class="img-default"
                          v-if="item.checked"
                          src="../../assets/images/select_checked.png"
                          alt
                        />
                        <img
                          class="img-default"
                          v-else
                          src="../../assets/images/select_unchecked.png"
                          alt
                        />
                      </div>
                    </div>

                    <router-link
                      :to="{
                        path: '/pages/goods/goods',
                        query: { id: item.goods_id },
                      }"
                      target="_blank"
                      class="goods-details d-flex align-items-center justify-content-center"
                      style="width: 28%"
                    >
                      <div class="goods-img">
                        <img class="img-default" :src="item.goods_pic" alt />
                      </div>
                      <div class="goods-name">{{ item.goods_name }}</div>
                    </router-link>
                    <div
                      class="goods-size d-flex justify-content-center"
                      style="width: 12%"
                    >
                      <div>
                        <div
                          class="goods-size-item"
                          v-for="(items, index) in item.attr_list"
                          :key="index"
                        >
                          {{ items.attr_group_name }}：{{ items.attr_name }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="goods-pic d-flex justify-content-center"
                      style="width: 18%"
                    >
                      ¥ {{ item.unitPrice }}
                    </div>
                    <div
                      class="goods-num d-flex justify-content-center"
                      style="width: 14%"
                    >
                      <template
                        v-if="item.max_num > 0 && item.max_num < item.num"
                      >
                        <p class="num-warning">仅剩库存{{ item.max_num }}个</p>
                      </template>
                      <el-input-number
                        v-model="item.num"
                        @change="handleChange(item.num, index)"
                        :min="1"
                        :max="
                          item.max_num >= item.num ? item.max_num : item.num
                        "
                        label="描述文字"
                      ></el-input-number>
                    </div>
                    <div
                      class="goods-subtotal d-flex justify-content-center"
                      style="width: 12%"
                    >
                      ¥ {{ (item.num * item.unitPrice).toFixed(2) }}
                    </div>
                    <div
                      class="goods-btn d-flex justify-content-center"
                      style="width: 12%"
                    >
                      <div>
                        <div
                          class="goods-btn-item goods-btn-itemer"
                          v-if="false"
                        >
                          收藏
                        </div>
                        <div
                          class="goods-btn-item"
                          @click="deleteItem(2, index)"
                        >
                          删除
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 套餐 -->
                  <div class="goods goods-group-box goods-group-boxen" v-else>
                    <div class="goods-group d-flex align-items-center">
                      <div
                        class="goods-checkbox-box d-flex align-items-center justify-content-center"
                        style="width: 4%"
                      >
                        <div
                          class="item checkWrap not-num"
                          v-if="item.status != 1 || item.goods_is_del == 1"
                        >
                          <div>失效</div>
                        </div>
                        <div
                          class="item checkWrap not-num"
                          v-else-if="item.disabled"
                        >
                          <div>无货</div>
                        </div>
                        <div
                          class="goods-checkbox"
                          @click="checkItem(2, index)"
                          v-else
                        >
                          <img
                            class="img-default"
                            v-if="item.checked"
                            src="../../assets/images/select_checked.png"
                            alt
                          />
                          <img
                            class="img-default"
                            v-else
                            src="../../assets/images/select_unchecked.png"
                            alt
                          />
                        </div>
                      </div>
                      <div
                        class="goods-details d-flex align-items-center"
                        style="width: 40%"
                        v-text="'【套装】' + item.title"
                      ></div>
                      <div
                        class="goods-pic d-flex justify-content-center"
                        style="width: 18%"
                        v-text="'¥ ' + item.price"
                      ></div>
                      <div
                        class="goods-num d-flex justify-content-center"
                        style="width: 14%"
                      >
                        <template
                          v-if="item.max_num > 0 && item.max_num < item.num"
                        >
                          <p class="num-warning">
                            仅剩库存{{ item.max_num }}个
                          </p>
                        </template>
                        <el-input-number
                          v-model="item.num"
                          @change="handleChange(item.num, index)"
                          :min="1"
                          :max="
                            item.max_num >= item.num ? item.max_num : item.num
                          "
                          label="描述文字"
                        ></el-input-number>
                      </div>
                      <div
                        class="goods-subtotal d-flex justify-content-center"
                        style="width: 12%"
                      >
                        ¥ {{ (item.num * item.price).toFixed(2) }}
                      </div>
                      <div
                        class="goods-btn d-flex justify-content-center"
                        style="width: 12%"
                      >
                        <div>
                          <div
                            class="goods-btn-item goods-btn-itemer"
                            v-if="false"
                          >
                            收藏
                          </div>
                          <div
                            class="goods-btn-item"
                            @click="deleteItem(3, index)"
                          >
                            删除
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 套餐项 -->
                    <template v-for="(itemChild, indexChild) in item.list">
                      <div class="goods-group-item d-flex align-items-center">
                        <router-link
                          :to="{
                            path: '/pages/goods/goods',
                            query: { id: itemChild.goods_id },
                          }"
                          target="_blank"
                          class="goods-details d-flex align-items-center justify-content-center"
                          style="width: 30%"
                        >
                          <div class="goods-img">
                            <img
                              class="img-default"
                              :src="itemChild.goods_pic"
                              alt
                            />
                          </div>
                          <div
                            class="goods-name show-two-lines"
                            v-text="itemChild.goods_name"
                          ></div>
                        </router-link>
                        <div
                          class="goods-size d-flex justify-content-center"
                          style="width: 11%"
                        >
                          <div>
                            <template
                              v-for="(
                                itemAttr, indexAttr
                              ) in itemChild.attr_list"
                            >
                              <div
                                class="goods-size-item"
                                v-text="
                                  itemAttr.attr_group_name +
                                  '：' +
                                  itemAttr.attr_name
                                "
                              ></div>
                            </template>
                          </div>
                        </div>
                        <div style="width: 18%"></div>
                        <div
                          class="goods-num d-flex justify-content-center"
                          style="width: 17%"
                        >
                          1件/x{{ item.num }}
                        </div>
                        <div style="width: 12%"></div>
                        <div
                          class="goods-btn d-flex justify-content-center"
                          style="width: 12%"
                        >
                          <div>
                            <div
                              class="goods-btn-item goods-btn-itemer"
                              v-if="false"
                            >
                              收藏
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </template>
          <!-- 购物车暂无商品时显示 -->
          <template v-else>
            <div class="zntj" v-if="datatype">
              <img
                class="img-default"
                src="../../assets/images/ttshop_zanwu.png"
                alt=""
              />
              <p>购物车空空如也</p>
            </div>
          </template>
          <!-- 未登录显示 -->
          <div class="noloding" v-if="login">
            <img
              class="img-default"
              src="../../assets/images/wloding.png"
              alt=""
            />
            <p>您还未登录 <span @click="goloding()">请登录</span></p>
          </div>
        </div>
        <div
          class="cat-bottom d-flex align-items-center justify-content-between"
        >
          <div class="cat-bottom-l d-flex align-items-center">
            <div
              class="bottom-item d-flex align-items-center justify-content-center"
              @click="checkAll()"
            >
              <div class="all-img">
                <img
                  class="img-default"
                  v-if="check_all"
                  src="../../assets/images/select_checked.png"
                  alt
                />
                <img
                  class="img-default"
                  v-else
                  src="../../assets/images/select_unchecked.png"
                  alt
                />
              </div>
              全选
            </div>
            <div class="cat-delete" @click="tempDelete()">删除选中商品</div>
            <div class="cat-collect" v-if="false">移到收藏</div>
          </div>
          <div class="cat-bottom-r d-flex align-items-center">
            <div class="select-shop">已选商品{{ num_all }}件</div>
            <div class="discounts" v-if="false">已优惠：-¥0.00</div>
            <div class="cat-line"></div>
            <div
              class="cat-pic d-flex flex-direction-column justify-content-between"
            >
              <div class="all-pic d-flex align-items-start">
                <strong>总价：</strong>
                <div class="all-pic-box">
                  <span>￥</span>
                  <span>{{ price_all }}</span>
                </div>
              </div>
            </div>
            <div
              class="cat-btn d-flex align-items-center justify-content-center"
              @click="submitPreview"
            >
              去结算
            </div>
          </div>
        </div>
        <!-- 热销模块 -->
        <div
          class="hot"
          v-if="cart_info.goods_list && cart_info.goods_list.length"
        >
          <div class="hot-tab d-flex">
            <template v-for="(item, index) in cart_info.goods_list">
              <div
                class="tab-item"
                @click="hotClick(index)"
                :class="{ hot_active: index == hot_index }"
              >
                热销
              </div>
            </template>
          </div>
          <div class="hot-swiper d-flex justify-content-between">
            <div class="hot-l swiper-button-prev">
              <img
                class="img-default"
                src="../../assets/images/img_left.png"
                alt
              />
            </div>
            <div class="img-list swiper-container d-flex">
              <div class="swiper-wrapper">
                <template
                  v-for="(item, index) in cart_info.goods_list[hot_index]"
                >
                  <router-link
                    :to="{ path: '/pages/goods/goods', query: { id: item.id } }"
                    target="_blank"
                    class="swiper-slide list-item d-flex flex-direction-column justify-content-between"
                  >
                    <div class="item-img">
                      <img class="img-default" :src="item.cover_pic" alt="" />
                    </div>
                    <div
                      class="item-name show-two-lines"
                      v-text="item.name"
                    ></div>
                    <!-- 价格面议 -->
                    <div class="item-pic" v-if="item.is_negotiable == 0">
                      ¥{{ item.price }}
                    </div>
                    <div class="item-pic" v-else>{{ item.price }}</div>
                  </router-link>
                </template>
              </div>
            </div>
            <div class="hot-r swiper-button-next">
              <img
                class="img-default"
                src="../../assets/images/img_right.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "./cat.css";
export default {
  inject: ["reload"],
  components: {
    Header,
    Foot,
  },
  data() {
    return {
      common_info: {
        store: {},
      },
      num: 1,
      hot_index: 0,
      datatype: false,
      cart_info: {},
      ttshop_catlist: [], //商品列表
      ttshop_mchlist: [], //店铺商品
      ttshop_num: "", //商品数量
      check_list: false,
      check_all: false,
      price_all: "0.00", //总金额
      num_all: 0, //商品总数
      searchtext: "",
      user: "", //是否登录
      login: false,
      dataTrackingParams: {
        scene: "购物车",
        type: 1,
      }, //埋点页面传参
    };
  },
  created() {
    let that = this;
    window.sessionStorage.setItem("alipay_type", ""); //清除支付宝支付状态
    this.common.loginType(this);
    this.common.getCommonInfo(this);
    if (!this.login) {
      this.shopcatapi();
    }
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key === 13) {
        if (that.$refs.searchtext.value) {
          that.searchshop();
        }
      }
    };
  },
  mounted() {},
  methods: {
    // 去登陆
    goloding() {
      this.$router.push({
        name: "signin",
        query: {
          redirect: this.$router.currentRoute.fullPath,
        },
      });
    },
    // 购物车数据
    shopcatapi(callback) {
      this.$loading();
      this.datatype = false;
      this.$api
        .shopcat()
        .then((res) => {
          this.$loading().close();
          let list = res.data.list;
          if (list) {
            for (let i in list) {
              if (list[i].parts_id != 0) {
                let status = 1; //1上架 其它则为下架商品
                let goods_is_del = 0; //0 正常 1已删除
                for (let j in list[i].list) {
                  if (list[i].list[j].status != 1) {
                    status = 0;
                  }
                  if (list[i].list[j].goods_is_del != 0) {
                    goods_is_del = 1;
                  }
                }
                list[i].status = status;
                list[i].goods_is_del = goods_is_del;
              }
            }
          }
          this.ttshop_catlist = list;
          this.ttshop_mchlist = res.data.mch_list;
          this.cart_info = res.data;
          this.datatype = true;
          this.hotSwiper();
          if (callback) {
            callback();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 热销轮播图
    hotSwiper() {
      setTimeout(() => {
        new Swiper(".img-list", {
          slidesPerView: 6,
          spaceBetween: 32,
          navigation: {
            nextEl: ".hot-r",
            prevEl: ".hot-l",
          },
        });
      }, 100);
    },
    // 搜索商品
    searchshop() {
      let searchname = this.$refs.searchtext.value;
      if (searchname == "") {
        this.$message({
          showClose: true,
          message: "搜索商品不可为空",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
      } else {
        let parms = {
          keyword: searchname,
          search: "search",
        };
        if (this.catid) {
          parms.id = this.catid;
        }
        this.$router.push({
          path: "/list",
          query: parms,
        });
      }
    },
    handleChange(value, index) {
      let that = this;
      let list = that.ttshop_catlist;
      let num = list[index].num;
      if (list[index].max_num >= num) {
        list[index].disabled = false;
      }
      that.ttshop_num = value;
      that.calculatePrice();
      that.throttle();
    },
    // 节流
    throttle() {
      let vaild = true;
      if (!vaild) {
        return false;
      }
      vaild = false;
      setTimeout(() => {
        this.modifycart();
        vaild = true;
      }, 800);
    },
    //购物车修改
    modifycart() {
      let that = this;
      let list = that.ttshop_catlist;
      let new_list = [];
      if (list) {
        for (let i in list) {
          if (list[i].parts_id != 0) {
            for (let j in list[i].list) {
              new_list.push(list[i].list[j]);
            }
          } else {
            new_list.push(list[i]);
          }
        }
      }
      let data = {
        list: JSON.stringify(new_list),
      };
      this.$api
        .modifycart(data)
        .then((res) => {
          // console.log(res)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 热销
    hotClick(e) {
      this.hot_index = e;
      this.hotSwiper();
    },
    // 全选
    checkAll() {
      let that = this;
      let list = that.ttshop_catlist;
      let mch_list = that.ttshop_mchlist;
      let check_all = !that.check_all;
      for (let i in list) {
        list[i].checked = check_all;
      }
      for (let i in mch_list) {
        mch_list[i].checked = check_all;
        for (let j in mch_list[i].list) {
          mch_list[i].list[j].checked = check_all;
        }
      }
      that.ttshop_catlist = list;
      that.ttshop_mchlist = mch_list;
      that.check_all = check_all;
      that.check_list = check_all;
      that.calculatePrice();
    },
    // 商品组选中
    checkGroup(types, index) {
      let that = this;
      let type = types;
      let list = that.ttshop_catlist;
      let mch_list = that.ttshop_mchlist;
      if (type == 1) {
        //mch_list
        let inx = index;
        mch_list[inx].checked = !mch_list[inx].checked;
        for (let i in mch_list[inx].list) {
          mch_list[inx].list[i].checked = mch_list[inx].checked;
        }
        that.ttshop_mchlist = mch_list;
      } else if (type == 2) {
        //list
        for (let i in list) {
          list[i].checked = !that.check_list;
        }
        that.ttshop_catlist = list;
        that.check_list = !that.check_list;
      }
      let check_all = true;
      if (!that.check_list && list.length) {
        check_all = false;
      }
      for (let i in mch_list) {
        if (!mch_list[i].checked && mch_list[i].list.length) {
          check_all = false;
        }
      }
      that.check_all = check_all;
      that.calculatePrice();
    },
    //单个商品选中
    checkItem(typeed, index, group_index) {
      let that = this;
      let type = typeed;
      let goods_inx = index;
      let goods_group_inx = group_index;
      let list = that.ttshop_catlist;
      let mch_list = that.ttshop_mchlist;
      if (type == 1) {
        //mch_list
        console.log(goods_inx);
        console.log(goods_group_inx);
        let group_type = true;
        mch_list[goods_group_inx].list[goods_inx].checked =
          !mch_list[goods_group_inx].list[goods_inx].checked;
        for (let i in mch_list[goods_group_inx].list) {
          if (
            !mch_list[goods_group_inx].list[i].checked &&
            !mch_list[goods_group_inx].list[i].disabled &&
            mch_list[goods_group_inx].list[i].status == 1 &&
            mch_list[goods_group_inx].list[i].goods_is_del == 0
          ) {
            group_type = false;
          }
        }
        mch_list[goods_group_inx].checked = group_type;
        that.ttshop_mchlist = mch_list;
      } else if (type == 2) {
        //list
        this.$set(list[goods_inx], "checked", !list[goods_inx].checked);
        let group_type = true;
        for (let i in list) {
          if (
            !list[i].checked &&
            !list[i].disabled &&
            list[i].status == 1 &&
            list[i].goods_is_del == 0
          ) {
            group_type = false;
          }
        }
        that.ttshop_catlist = list;
        that.check_list = group_type;
      }
      //
      let check_all = true;
      if (!that.check_list && list.length) {
        check_all = false;
      }
      for (let i in mch_list) {
        if (!mch_list[i].checked && mch_list[i].list.length) {
          check_all = false;
        }
      }
      that.check_all = check_all;
      that.calculatePrice();
    },
    // 单个商品删除
    deleteItem(typer, index, group_index) {
      let that = this;
      let type = typer;
      let goods_inx = index;
      let goods_group_inx = group_index;
      let list = that.ttshop_catlist;
      let mch_list = that.ttshop_mchlist;
      let remove_cart_id = [];
      if (type == 1) {
        //mch_list商品
        remove_cart_id.push(mch_list[goods_group_inx].list[goods_inx].cart_id);
        mch_list[goods_group_inx].list.splice(goods_inx, 1);
        if (mch_list[goods_group_inx].list.length <= 0) {
          mch_list.splice(goods_group_inx, 1);
        }
        that.ttshop_mchlist = mch_list;
      } else if (type == 2) {
        //list商品
        remove_cart_id.push(list[goods_inx].cart_id);
        list.splice(goods_inx, 1);
        that.ttshop_catlist = list;
      } else if (type == 3) {
        //list优惠套餐
        for (let i in list[goods_inx].list) {
          remove_cart_id.push(list[goods_inx].list[i].cart_id);
        }
        list.splice(goods_inx, 1);
        that.ttshop_catlist = list;
      }
      that.calculatePrice();
      that.deleteFun(remove_cart_id);
    },
    // 底部删除
    tempDelete() {
      let that = this;
      let id_arr = [];
      let list = that.ttshop_catlist;
      let mch_list = that.ttshop_mchlist;
      for (let i in list) {
        if (list[i].checked) {
          id_arr.push(list[i].cart_id);
        }
      }
      for (let i in mch_list) {
        for (let j in mch_list[i].list) {
          if (mch_list[i].list[j].checked) {
            id_arr.push(mch_list[i].list[j].cart_id);
          }
        }
      }
      if (id_arr.length) {
        this.$confirm("确认将这" + id_arr.length + "个商品删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            this.deleteFun(id_arr, function callback() {
              that.shopcatapi(function callback() {
                that.calculatePrice();
                this.reload();
              });
            });
          })
          .catch(() => {
            // this.$message({
            // 	type: 'info',
            // 	message: '已取消删除'
            // });
          });
      }
    },
    // 删除商品请求接口
    deleteFun(remove_cart_id, callback) {
      let data = {
        cart_id_list: JSON.stringify(remove_cart_id),
      };
      this.$api
        .delectshop(data)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              showClose: false,
              message: res.msg,
              center: true,
              type: "success",
              offset: 200,
              duration: 1000,
            });
            this.reload();
            if (callback) {
              callback();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 计算价格
    calculatePrice() {
      let that = this;
      let list = that.ttshop_catlist;
      let mch_list = that.ttshop_mchlist;
      let price = 0;
      let num = 0;
      for (let i in list) {
        if (
          list[i].checked &&
          !list[i].disabled &&
          list[i].status == 1 &&
          list[i].goods_is_del == 0
        ) {
          price +=
            Number(list[i].num) * Number(list[i].unitPrice) ||
            Number(list[i].num) * Number(list[i].price);
          num += Number(list[i].num);
        }
      }
      for (let i in mch_list) {
        for (let j in mch_list[i].list) {
          if (
            mch_list[i].list[j].checked &&
            !mch_list[i].list[j].disabled &&
            mch_list[i].list[j].status == 1 &&
            mch_list[i].list[j].goods_is_del == 0
          ) {
            price +=
              Number(mch_list[i].list[j].num) *
              Number(mch_list[i].list[j].unitPrice);
            num += Number(mch_list[i].list[j].num);
          }
        }
      }
      that.price_all = price.toFixed(2);
      that.num_all = num;
    },
    // 结算
    submitPreview() {
      let that = this;
      let list = that.ttshop_catlist;
      let mch_list = that.ttshop_mchlist;
      let new_arr = []; //待提交数组
      let list_check = []; //自营选中商品
      let list_jd = []; //京东vop的商品
      let list_yzh = []; //云中鹤的商品
      // 自营选中商品
      for (let i in list) {
        if (
          list[i].checked &&
          !list[i].disabled &&
          list[i].status == 1 &&
          list[i].goods_is_del == 0
        ) {
          if (list[i].parts_id != 0) {
            for (let j in list[i].list) {
              if (list[i].source == 6) {
                list_jd.push({
                  cart_id: list[i].list[j].cart_id,
                });
              } else if (list[i].source == 7) {
                list_yzh.push({
                  cart_id: list[i].list[j].cart_id,
                });
              } else {
                list_check.push({
                  cart_id: list[i].list[j].cart_id,
                });
              }
            }
          } else {
            if (list[i].source == 6) {
              list_jd.push({
                cart_id: list[i].cart_id,
              });
            } else if (list[i].source == 7) {
              list_yzh.push({
                cart_id: list[i].cart_id,
              });
            } else {
              list_check.push({
                cart_id: list[i].cart_id,
              });
            }
          }
        }
      }
      if (list_check.length > 0) {
        new_arr.push({
          mch_id: 0,
          goods_list: list_check,
        });
      }
      if (list_jd.length > 0) {
        new_arr.push({
          mch_id: "jdvop",
          goods_list: list_jd,
        });
      }
      if (list_yzh.length > 0) {
        new_arr.push({
          mch_id: "yzh",
          goods_list: list_yzh,
        });
      }
      // 店铺选中商品
      for (let i in mch_list) {
        let goods_list = [];
        for (let j in mch_list[i].list) {
          if (
            mch_list[i].list[j].checked &&
            !mch_list[i].list[j].disabled &&
            mch_list[i].list[j].status == 1 &&
            mch_list[i].list[j].goods_is_del == 0
          ) {
            goods_list.push({
              cart_id: mch_list[i].list[j].cart_id,
            });
          }
        }
        if (goods_list.length > 0) {
          new_arr.push({
            mch_id: mch_list[i].id,
            goods_list: goods_list,
          });
        }
      }
      if (new_arr.length > 0) {
        let data = {
          //埋点
          web_url: this.$route.path,
          type: 1,
          scene: "结算",
          is_order: 1,
        };
        let paramsOBJ = this.common.publicPage(this, data);
        console.log(this.common.publicPage(this, data));
        this.$api.statistics_data(paramsOBJ).then((res) => {
          console.log(res);
        });
        let params = {
          mch_list: JSON.stringify(new_arr),
        };
        this.$store.commit("submitOrderRarams", params);
        this.$router.push({
          name: "submitOrder",
        });
      } else {
        this.$message({
          showClose: true,
          message: "您还没有选择商品哦",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hot_active {
  border-top: 2px solid #ff0e25;
  background-color: #fff;
  color: #ff0e25;
}

.coupon_active {
  color: #ffffff;
  background-color: #ff0e25 !important;
  border-radius: 0 none !important;
}

.checkWrap {
  div {
    padding: 2px 5px;
    box-sizing: border-box;
    background: #ccc;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    cursor: no-drop;
  }
}

.search {
  height: 112px;
  background-color: #fff;
  width: 100%;

  .search-box {
    height: 112px;

    .logo {
      a {
        display: block;
        width: 187px;
        height: 55px;
        .search-img {
          width: auto;
          height: auto;
          object-fit: fill;
          display: block;
          margin: 0 auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      .logo-img {
        width: 187px;
        height: 55px;
        object-fit: fill;
      }

      .logo-line {
        width: 1px;
        height: 55px;
        background: #ebebeb;
        margin-left: 24px;
        margin-right: 20px;
      }

      .shoper {
        width: 140px;
        font-size: 20px;
        color: #666666;
        margin-left: 18px;
      }
    }

    .search-c {
      margin-left: auto;

      .search-item {
        display: flex;

        .box {
          width: 310px;
          height: 36px;
          border: 2px solid #ff0008;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .img {
            height: 10px;
            width: 10px;
            margin-left: 10px;
            margin-right: 4px;
          }

          .search-input {
            width: 100%;
            height: 32px;
            // border: 0 none;
            // box-sizing: border-box;
          }
        }

        .search-btn {
          width: 90px;
          height: 36px;
          background-color: #ff0008;
          color: #fff;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }
}

.title {
  height: 40px;
  width: 100%;
  background-color: #fafafa;

  .title-item {
    color: #666666;
    font-size: 14px;
  }

  .all-img {
    height: 12px;
    width: 12px;
    margin-right: 8px !important;
  }
}

.checkbox {
  cursor: pointer;
  height: 12px;
  width: 12px;
}

.catshop {
  .shop-title {
    margin: 20px 0 8px 19px;
    box-sizing: border-box;
    height: 36px;

    .shop-name {
      margin-left: 8px;
      margin-right: 4px;
      font-size: 14px;
      font-weight: bold;
    }

    .coupon-box {
      position: relative;
      margin-left: 20px;

      &:hover .coupon {
        border-color: #ff0e25;
        border-bottom-color: #fff;
        z-index: 10;
      }

      &:hover .coupon-po {
        z-index: 1;
        visibility: visible;
      }

      &:hover .coupon-img {
        transform: rotate(-180deg);
        -ms-transform: rotate(-180deg);
        -moz-transform: rotate(-180deg);
        -webkit-transform: rotate(-180deg);
        -o-transform: rotate(-180deg);
      }

      .coupon {
        padding: 8px;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid transparent;
        border-radius: 2px 2px 0px 0px;
        position: relative;
        z-index: 1000;

        .item {
          height: 20px;
          cursor: pointer;

          .item-l {
            width: 32px;
            background-image: url(../../assets/images/coupon_item.png);
            background-repeat: no-repeat;
            color: #fff;
          }

          .item-r {
            padding: 0 8px;
            box-sizing: border-box;
            background-color: #fff0f1;
            color: #ff0e25;
          }
        }

        .coupon-img {
          height: 14px;
          width: 14px;
          margin-left: 4px;
          transition: 0.35s;
          -moz-transition: 0.35s;
          -webkit-transition: 0.35s;
          -o-transition: 0.35s;
        }
      }

      .coupon-po {
        position: absolute;
        top: 37px;
        left: 0px;
        width: 476px;
        border: 1px solid #ff0e25;
        background-color: #fff;
        visibility: hidden;
        z-index: 1;
        border-radius: 0px 2px 2px 2px;
        padding: 8px 0;
        box-sizing: border-box;

        .coupon-po-item {
          height: 62px;
          padding: 0 20px;
          box-sizing: border-box;

          &:hover {
            background-color: #fff0f1;
          }
        }

        .coupon-po-img {
          width: 64px;
          height: 32px;
          background-image: url(../../assets/images/coupon_po_img.png);
          background-repeat: no-repeat;

          .coupon-po-name {
            font-size: 20px;
            color: #fff;

            span {
              color: #fff;
            }
          }
        }

        .coupon-time {
          margin-left: 16px;

          :first-child {
            font-size: 14px;
          }

          :last-child {
            color: #999999;
          }
        }

        .coupon-btn {
          width: 72px;
          height: 28px;
          background: #fff0f1;
          border-radius: 2px;
          border: 1px solid #ff3346;
          color: #ff0e25;
          margin-left: auto;
        }
      }
    }
  }

  .goods-box {
    .goods:first-child {
      border-top: 1px solid #ebebeb !important;
    }

    .goods {
      border: 1px solid #ebebeb;
      box-sizing: border-box;
      border-top: 0;
      padding: 20px 0;

      .goods-checkbox {
        height: 12px;
        width: 12px;
      }

      .goods-details {
        .goods-img {
          height: 80px;
          width: 80px;
          margin-right: 16px;
        }

        .goods-name {
          width: 230px;
          height: 36px;
          color: #666666;
          line-height: 18px;
          overflow: hidden;
        }
      }

      .goods-size {
        .goods-size-item {
          padding: 0 8px;
          box-sizing: border-box;
          color: #666666;
        }
      }

      .goods-pic {
        color: #666666;
      }

      .goods-subtotal {
        color: #666666;
      }

      .goods-btn {
        .goods-btn-item {
          color: #666666;
          cursor: pointer;

          &:hover {
            color: #ff0e25;
          }
        }
      }

      .goods-group {
        padding-bottom: 20px;
        box-sizing: border-box;
      }

      .goods-group-item {
        // margin-left: auto;
        padding: 20px 0;
        margin-left: 4%;
        box-sizing: border-box;
        border-top: 1px dashed #d9d9d9;
      }
    }

    .goods-group-box {
      padding-bottom: 0 !important;
    }
  }

  .zntj {
    width: 100%;
    padding: 40px 10px;
    box-sizing: border-box;

    img {
      display: block;
      width: 93px;
      height: 80px;
      margin: 0 auto 20px;
    }

    p {
      font-size: 14px;
      color: #333;
      text-align: center;
    }
  }

  .noloding {
    width: 100%;
    padding: 40px 10px;
    box-sizing: border-box;

    img {
      display: block;
      width: 198px;
      height: 128px;
      margin: 0 auto 20px;
    }

    p {
      font-size: 14px;
      color: #333;
      text-align: center;

      span {
        padding: 2px 8px;
        box-sizing: border-box;
        font-size: 14px;
        color: #fff;
        border-radius: 2px;
        background: #ff0e25;
        cursor: pointer;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;

        &:hover {
          box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
        }
      }
    }
  }
}

// 底部按钮
.cat-bottom {
  height: 60px;
  background: #ffffff;
  border: 1px solid #ebebeb;
  margin-top: 48px;

  .bottom-item {
    color: #666666;
    margin-left: 18px;
    cursor: pointer;
  }

  .all-img {
    height: 12px;
    width: 12px;
    margin-right: 8px !important;
  }

  .cat-delete {
    color: #666666;
    margin-left: 40px;
    cursor: pointer;

    &:hover {
      color: #ff0e25;
    }
  }

  .cat-collect {
    cursor: pointer;
    color: #666666;
    margin-left: 20px;

    &:hover {
      color: #ff0e25;
    }
  }

  .cat-bottom-r {
    .select-shop {
      color: #666666;

      span {
        color: #ff9010;
        margin-left: 8px;
      }
    }

    .discounts {
      margin-left: 24px;
      color: #666666;
    }

    .cat-line {
      width: 1px;
      height: 40px;
      background: #ebebeb;
      margin: 0 24px;
    }

    .cat-btn {
      width: 132px;
      height: 60px;
      background: #ff0e25;
      color: #ffffff;
      font-size: 18px;
      cursor: pointer;
    }

    .cat-pic {
      height: 40px;
      margin-right: 20px;
      color: #666666;

      .all-pic {
        color: #666666;
        line-height: 40px;
        padding-top: 5px;
        box-sizing: border-box;

        strong {
          font-weight: 400;
          color: #666;
        }

        .all-pic-box {
          span:first-child {
            color: #ff4300;
            display: inline-block;
            font-weight: bold;
          }

          span:last-child {
            font-size: 22px;
            color: #ff4300;
            display: inline-block;
            line-height: 22px;
            font-weight: bold;
          }
        }
      }

      .freight {
        color: #666666;
      }
    }
  }
}

.cat-bottom:last-child {
  margin-bottom: 56px;
}

//热销模块
.hot {
  width: 100%;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  margin: 56px 0;

  .hot-tab {
    height: 32px;
    background-color: #fafafa;

    .tab-item {
      text-align: center;
      cursor: pointer;
      min-width: 100px;
      height: 32px;
      line-height: 32px;
      padding: 0 26px;
      box-sizing: border-box;
      font-size: 16px;
    }
  }

  .hot-swiper {
    padding: 32px;
    box-sizing: border-box;
    position: relative;

    .hot-l {
      // margin-top: 65px;
      width: 12px;
      height: 20px;
      background-image: none;
      left: 32px;
      outline: none;
      top: 127px;
    }

    .img-list {
      width: 1060px;
      overflow: hidden;

      .list-item {
        // display: inline-block;
        height: 222px;

        .item-img {
          width: 150px;
          height: 150px;
          background: #ccc;
        }

        .item-name:hover {
          color: #ff4300;
        }

        .item-pic {
          font-size: 16px;
          color: #ff4300;
          font-weight: bold;
        }
      }
    }

    .hot-r {
      width: 12px;
      height: 20px;
      background-image: none;
      right: 32px;
      outline: none;
      top: 127px;
    }
  }
}
.num-warning {
  color: #999;
  margin-left: 15px;
  margin-bottom: 10px;
}
.goods .goods-num {
  flex-direction: column;
}
</style>
